interface NormalizedObject {
    [key: string]: any;
  }
  
  export function normalizeKeys<T extends { [key: string]: any }>(data: T[]): T[] {
    if (!data || !Array.isArray(data)) {
      console.warn('normalizeKeys was called with invalid data', data);
      return [];
    }
  
    return data.map((item) => {
      const normalizedItem: NormalizedObject = {};
      Object.keys(item).forEach((key) => {
        const newKey = key.toLowerCase().replace(/(?:^|_)(\w)/g, (_, c) => c.toUpperCase());
        normalizedItem[newKey] = item[key];
      });
      return normalizedItem as T;
    });
  }